
























































































































































































































































import { defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import ContentReview from '~/components/partials/Content/ContentReview.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { useWineIntroduction } from '~/composables/contents/useWineIntroduction';
import { BOTTLE_400 } from '~/constants/profilesForImage';
import { nonNullable } from '~/utils';
import { DynamicPartsWineIntroduction } from '~/types/modules/contents';
import { ProductStockCard } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppPrice,
    AppImage,
    AppLink,
    AppRectButton,
    ContentReview,
    ProducingAreaFlag,
    ProductCartButton,
    ProductLabel,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsWineIntroduction>,
      required: true,
    },
    productCode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const {
      url,
      producingArea,
      productDetailUrl,
      ecDetailResponse,
      filteredReviews,
      stockList,
      threeLineCatchCopies,
      catchCopies,
      hasStock,
      isNowOnSale,
      isShowNew,
      getAromaImageUrl,
      AromaType,
      producer,
      productName,
      isActiveModal,
      review,
      currentLang,
      DisplayLang,
      PRODUCT_CART_BUTTON,
    } = useWineIntroduction(props);

    /** 商品ラベル(NEWラベルと〇%OFFラベルは位置が異なるため除外) */
    const productLabels = (variant: ProductStockCard) => {
      if (isActiveModal.value) return [];
      return [
        variant.isFreeShipping
          ? {
              text: i18n.t('Content-05.free.shipping.label').toString(),
              class: 'bg-LabelBg text-WineRed',
            }
          : null,
        variant.saleLabel
          ? {
              text: variant.saleLabel,
              color: 'Sale',
            }
          : null,
        variant.isLimitedStock
          ? {
              text: i18n.t('Content-05.limit.number').toString(),
              outline: 'Gray',
            }
          : null,
        ...variant.sameProductPromotionNames.map((label) => ({
          text: label,
          color: 'Sale',
        })),
        ...variant.multiProductPromotionNames.map((promotion) => ({
          text: promotion,
          color: 'Sale',
        })),
        variant.isOnlineCampaign
          ? {
              text: i18n.t('Item-03.label.onlineOnlyCampaign').toString(),
              outline: 'Gray',
            }
          : null,
        variant.isD1Target
          ? {
              text: i18n.t('Item-03.label.expeditedShipping').toString(),
              outline: 'Gray',
              icon: 'ExpeditedShipping',
            }
          : null,
      ].filter(nonNullable);
    };

    return {
      url,
      producingArea,
      productDetailUrl,
      ecDetailResponse,
      filteredReviews,
      stockList,
      threeLineCatchCopies,
      catchCopies,
      hasStock,
      isNowOnSale,
      isShowNew,
      getAromaImageUrl,
      AromaType,
      producer,
      productName,
      isActiveModal,
      review,
      currentLang,
      DisplayLang,
      PRODUCT_CART_BUTTON,
      BOTTLE_400,
      dayjs,
      productLabels,
    };
  },
});
